import { IPatient } from './patient.interface';

export interface IPatientsResponse {
  patients: IPatient[];
  totalСount: number;
}
